export const selectFactoryAdvanceOptions = (state) => state.factoryAdvanceOptions.advance.options;
export const selectFactoryNode = (state)=> state.factoryAdvanceOptions.advance.node;

export const selectFactoryAdvanceOptionsLoading = (state) => state.factoryAdvanceOptions.loading;
export const selectFactoryAdvanceOptionsError = (state) => state.factoryAdvanceOptions.error;